var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 15,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.37.833C13.822.267 11.7 0 9 0c-2.7 0-4.787.267-6.335.833C.432 1.633 0 2.833 0 3.7v11.567c0 1.266.72 2.333 2.16 2.566v1.1C2.16 19.5 2.7 20 3.312 20h1.152c.611 0 1.295-.467 1.295-1.067V18h6.48v.933c0 .567.684 1.067 1.295 1.067h1.152c.612 0 1.152-.467 1.152-1.067v-1.1c1.44-.233 2.16-1.3 2.16-2.566V3.7c.036-.9-.396-2.1-2.628-2.867zM5.04 2h7.955c.324 0 .575.367.575.667 0 .3-.251.666-.575.666H5.039c-.324 0-.575-.366-.575-.666 0-.3.287-.667.575-.667zM3.923 15.515c-.766 0-1.385-.573-1.385-1.282 0-.709.619-1.281 1.385-1.281.765 0 1.384.572 1.384 1.281 0 .682-.619 1.282-1.384 1.282zm10 0c-.766 0-1.385-.573-1.385-1.282 0-.709.619-1.281 1.385-1.281.765 0 1.384.572 1.384 1.281 0 .682-.619 1.282-1.384 1.282zM3.276 9.633v-4.3H14.794v4.334L3.276 9.633z",
    fill: "#4A4A4A",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSb);
export default __webpack_public_path__ + "static/media/sb.30bfe3cd2101daf0968e789c275e2868.svg";
export { ForwardRef as ReactComponent };